module.exports = {
    "breadcrumbs": `\u{5C0E}\u{89BD}\u{5217}`
};


//# sourceMappingURL=zh-TW.main.js.map
